import React, { useRef } from 'react';
import Slider from 'react-slick';
import timeBadge from 'assets/images/time-badge.svg';
import loadable from '@loadable/component';

const LazyImg = loadable(() => import('../common/LazyImg'));

const BoxContent = () => {
  const sliderRef = useRef(null);

  const timelineCardStyles = {
    2018: {
      paddingBottom: '103px',
    },
    2019: {
      minHeight: '290px',
    },
    2020: {
      minHeight: '270px',
    },
    2021: {
      minHeight: '233px',
    },
    2022: {
      minHeight: '212px',
      paddingBottom: '24px',
    },
  };

  const goTofirst = () => {
    sliderRef.current.slickGoTo(0);
  };
  const beforeChangeHandle = (current, next) => {
    if (next === current) {
      setTimeout(() => {
        goTofirst();
      }, 2000);
    }
  };

  // TODO: need to refactor appendDots component
  const settings = {
    dots: false,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: false,
    autoplay: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    autoplaySpeed: 2400,
    waitForAnimate: false,
    appendDots: dots => (
      <div>
        <ul style={{
          display: 'flex',
        }}
        >
          {' '}
          {dots}
          {' '}
        </ul>
      </div>
    ),
    responsive: [{
      breakpoint: 1399,
      settings: {
        dots: true,
        slidesToShow: 4,
        afterChange: idx => beforeChangeHandle(1, idx),
      },
    }, {
      breakpoint: 1024,
      settings: {
        dots: true,
        slidesToShow: 3,
        afterChange: idx => beforeChangeHandle(2, idx),
      },
    }, {
      breakpoint: 780,
      settings: {
        dots: true,
        slidesToShow: 2,
        afterChange: idx => beforeChangeHandle(3, idx),
      },
    }],
  };

  return (
    <section className='box-content'>
      <div className='container'>
        <Slider {...settings} ref={sliderRef} className='slick-slider box-content__grid box-content__slick'>
          <div className='box-content__column'>
            <div className='box-content__card' style={timelineCardStyles[2018]}>
              <h3 className='box-content__title'>2018</h3>
              <div className='box-content__description'>
                <p>
                  Three dads living in Shanghai set out to build the best air purifir on the market, naming
                  it
                  after one of their own daughters.
                </p>
              </div>
            </div>
          </div>
          <div className='box-content__column'>
            <div className='box-content__card' style={timelineCardStyles[2019]}>
              <h3 className='box-content__title'>2019</h3>
              <div className='box-content__description'>
                <p>
                  Mila launches on Kickstarter as the most successful (and smartest) air purifier in
                  crowdfunding history.
                  {' '}
                </p>
              </div>
            </div>
          </div>
          <div className='box-content__column'>
            <div className='box-content__card' style={timelineCardStyles[2020]}>
              <h3 className='box-content__title'>2020</h3>
              <div className='box-content__description'>
                <p>Mila goes global — shipping in Canada, Australia and the UK. </p>
              </div>
            </div>
          </div>

          <div className='box-content__column'>
            <div className='box-content__card' style={timelineCardStyles[2021]}>
              <h3 className='box-content__title'>2021</h3>
              <div className='box-content__description'>
                <p>Mila named one of TIME’s Best Inventions of the year. </p>
              </div>
              <figure className='box-content__badge'>
                <LazyImg src={timeBadge} alt='Time best investigation' />
              </figure>
            </div>
          </div>

          <div className='box-content__column'>
            <div className='box-content__card' style={timelineCardStyles[2022]}>
              <h3 className='box-content__title'>2022</h3>
              <div className='box-content__description'>
                <p>Mila introduces Mila Halo —the humidifier, reinvented.</p>
              </div>
              <div className='box-content__slogan'><p>And this is where you come in ...</p></div>
            </div>
          </div>
        </Slider>
      </div>
    </section>
  );
};

export default BoxContent;
